import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "flex-row"
}
const _hoisted_3 = {
  key: 0,
  class: "custom-textarea mr20"
}
const _hoisted_4 = { class: "main-img-container" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "action-bar" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "content-img-container" }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "action-list" }
const _hoisted_12 = { class: "action-list" }
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Boolean(_ctx.t) && _ctx.tab_type != 2)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          class: "mb20",
          title: `审核状态：${_ctx.CheckStatus[_ctx.formData.check_status]}`,
          type: _ctx.formData.check_status === _ctx.CheckStatus['驳回'] ? 'error' : 'info',
          description: `${_ctx.formData.reject_reason ? '驳回原因：'+_ctx.formData.reject_reason : '' }`
        }, null, 8, ["title", "type", "description"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      class: "form",
      ref: "productForm",
      model: _ctx.formData,
      rules: _ctx.productRules,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "品牌：",
          prop: "brand_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.brand_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
              ref: "brandRef",
              filterable: "",
              placeholder: "请选择",
              disabled: _ctx.t==='view' || Boolean(_ctx.t) && _ctx.formData.check_status != 0,
              onChange: _ctx.onBrandChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "onChange"])
          ]),
          _: 1
        }),
        (_ctx.formData.brand_cat_id==5)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "二级品牌名称："
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.sbrand_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.sbrand_id) = $event)),
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择二级品牌",
                  disabled: _ctx.t==='view' || Boolean(_ctx.t) && _ctx.formData.check_status != 0 && _ctx.formData.check_status != 3
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondBrandList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "品类：",
          prop: "cat_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.cat_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.cat_id) = $event)),
              filterable: "",
              placeholder: "请选择",
              disabled: _ctx.t==='view' || Boolean(_ctx.t) && _ctx.formData.check_status != 0
            }, {
              default: _withCtx(() => [
                (_ctx.formData.brand_cat_id==_ctx.BrandCat['蛋糕'] || _ctx.formData.brand_cat_id==_ctx.BrandCat['零食'] || Boolean(_ctx.t))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_option, {
                        label: "蛋糕",
                        value: _ctx.BrandCat['蛋糕']
                      }, null, 8, ["value"]),
                      _createVNode(_component_el_option, {
                        label: "零食",
                        value: _ctx.BrandCat['零食']
                      }, null, 8, ["value"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.formData.brand_cat_id==_ctx.BrandCat['鲜花'] || Boolean(_ctx.t))
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 1,
                      label: "鲜花",
                      value: _ctx.BrandCat['鲜花']
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "是否预售商品：",
          prop: "is_pre_sale"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.is_pre_sale,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.is_pre_sale) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => _cache[64] || (_cache[64] = [
                    _createTextVNode("是")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 0 }, {
                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                    _createTextVNode("否")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_ctx.formData.is_pre_sale)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "预售日期",
              prop: "pre_sale_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.pre_sale_date,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.pre_sale_date) = $event)),
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  type: "date",
                  "disabled-date": _ctx.disabledPreSaleDate,
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择预售日期"
                }, null, 8, ["modelValue", "disabled", "disabled-date"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "开通城市：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.city_ids,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.city_ids) = $event)),
              filterable: "",
              multiple: "",
              placeholder: "请选择",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  class: "el-select_checkbox",
                  modelValue: _ctx.isSelectedAll,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isSelectedAll) = $event)),
                  indeterminate: _ctx.isIndeterminate,
                  label: "全选",
                  onChange: _ctx.onIsSelectedAllChange
                }, null, 8, ["modelValue", "indeterminate", "onChange"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityList, (group) => {
                  return (_openBlock(), _createBlock(_component_el_option_group, {
                    key: group.lable,
                    label: group.lable
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.lable,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            _cache[66] || (_cache[66] = _createElementVNode("span", {
              class: "suffix",
              style: {"margin-left":"10px","color":"#E6A23C"}
            }, "注：如该商品和品牌配送城市一致，请勿填写", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "商品名称：",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: _normalizeClass(_ctx.t==='check' && _ctx.formData.old_title ? 'danger' : ''),
              modelValue: _ctx.formData.title,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.title) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || Boolean(_ctx.t) && _ctx.formData.check_status != 0
            }, _createSlots({ _: 2 }, [
              (_ctx.formData.is_pre_sale)
                ? {
                    name: "prefix",
                    fn: _withCtx(() => [
                      _cache[67] || (_cache[67] = _createTextVNode("【预售】"))
                    ]),
                    key: "0"
                  }
                : undefined,
              (_ctx.t==='check' && _ctx.formData.old_title)
                ? {
                    name: "prepend",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.old_title), 1)
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1032, ["class", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "商品介绍：",
          prop: "description"
        }, {
          default: _withCtx(() => [
            (_ctx.t==='check')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.formData.old_description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formData.old_description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["custom-textarea", _ctx.formData.old_description ? 'danger': ''])
                  }, _toDisplayString(_ctx.formData.description), 3)
                ]))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  autosize: {minRows: 4},
                  modelValue: _ctx.formData.description,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.description) = $event)),
                  type: "textarea",
                  maxlength: "500",
                  "show-word-limit": "",
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, null, 8, ["modelValue", "disabled"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "image-form-item",
          label: "商品图：",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.formData.images,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.images) = $event)),
              class: "flex-row",
              onEnd: _ctx.onImgMoveEnd
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.images, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex-row-item",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_image, {
                        class: "main-img",
                        src: item.url,
                        "preview-src-list": _ctx.mainPreviewList,
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        "append-to-body": "",
                        "z-index": 3000
                      }, null, 8, ["src", "preview-src-list"])
                    ]),
                    _createElementVNode("div", {
                      class: "ellipsis",
                      title: item.file_name
                    }, _toDisplayString(item.file_name), 9, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.image_id,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.image_id) = $event)),
                        label: item.id,
                        disabled: _ctx.t==='view' || _ctx.t==='check'
                      }, {
                        default: _withCtx(() => _cache[68] || (_cache[68] = [
                          _createTextVNode("列表图")
                        ])),
                        _: 2
                      }, 1032, ["modelValue", "label", "disabled"]),
                      (_ctx.t!=='view' && _ctx.t!=='check')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "color-primary",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.onImgRemove(index, 1))
                          }, "删除", 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                _createVNode(_component_el_upload, {
                  ref: "imageUpload",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  class: "el-upload-list__item empty-item",
                  accept: ".jpg,.jpeg,.png",
                  action: "uploadUrl",
                  "before-upload": _ctx.onBeforeUpload,
                  "http-request": _ctx.onImgUpload,
                  "file-list": _ctx.formData.images,
                  "show-file-list": false,
                  "list-type": "picture-card",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "before-upload", "http-request", "file-list"])
              ]),
              _: 1
            }, 8, ["modelValue", "onEnd"]),
            _cache[69] || (_cache[69] = _createElementVNode("div", { class: "tips" }, "注：商品图宽高为 800*800，且不大于500k", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "详情图：",
          required: "",
          class: "content-img-form-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.formData.content_images,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.content_images) = $event)),
              class: "flex-row",
              onEnd: _ctx.onContentImgMoveEnd
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.content_images, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex-row-item preview-item",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_image, {
                        class: "content-img",
                        src: item.url,
                        "preview-src-list": _ctx.contentImgPreviewList,
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        "append-to-body": "",
                        "z-index": 3000
                      }, null, 8, ["src", "preview-src-list"])
                    ]),
                    _createElementVNode("div", {
                      class: "ellipsis",
                      title: item.file_name
                    }, _toDisplayString(item.file_name), 9, _hoisted_9),
                    (_ctx.t!=='view' && _ctx.t!=='check')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "icon el-icon-delete",
                          onClick: ($event: any) => (_ctx.onImgRemove(index, 2))
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createVNode(_component_el_upload, {
                  ref: "imageUpload",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  class: "el-upload-list__item empty-item",
                  accept: ".jpg,.jpeg,.png",
                  action: "uploadUrl",
                  "before-upload": _ctx.onContentBeforeUpload,
                  "http-request": _ctx.onContentImgUpload,
                  "file-list": _ctx.formData.content_images,
                  "show-file-list": false,
                  "list-type": "picture-card",
                  multiple: "",
                  style: {"width":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "before-upload", "http-request", "file-list"])
              ]),
              _: 1
            }, 8, ["modelValue", "onEnd"]),
            _cache[70] || (_cache[70] = _createElementVNode("div", { class: "tips" }, "注：图片宽度为750，且不大于500k", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "发票类型：",
          prop: "invoice_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.invoice_type,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.invoice_type) = $event)),
              placeholder: "请选择发票类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "专票",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "普票",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "无票",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "其他",
                  value: 4
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "税点：",
          prop: "tax_Point"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.tax_Point,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.tax_Point) = $event)),
              modelModifiers: { trim: true },
              placeholder: "请输入税点",
              maxlength: "2",
              onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.tax_Point=_ctx.formData.tax_Point.replace(/^\.+|[^\d.]/g,'')))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (group, index) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: group.group_name,
            label: group.group_name,
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.tagIdList[index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.formData.tagIdList[index]) = $event),
                filterable: "",
                multiple: "",
                placeholder: "请选择",
                disabled: _ctx.t==='view' || _ctx.t==='check'
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (tag) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: tag.id,
                      label: tag.name,
                      value: `${tag.id}`
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128)),
        _createVNode(_component_el_form_item, {
          class: "table-form-item",
          label: "规格：",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.formData.specs,
              border: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "规格",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "description",
                  label: "规格描述"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "tastes",
                  label: "口味/颜色",
                  width: "90"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "market_price",
                  label: "市场价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  label: "售价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "stock",
                  label: "库存",
                  width: "90"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "clearing_price",
                  label: "结算价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "gift",
                  label: "默认赠品"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "sku",
                  label: "SKU"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shop_discount",
                  label: "规格折扣"
                }),
                _createVNode(_component_el_table_column, { label: "是否隐藏" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.delete ? '是' : '否'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "150"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_ctx.delSpec(scope.$index)), ["prevent"]),
                        disabled: _ctx.t==='view' || _ctx.t==='check'
                      }, {
                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                          _createTextVNode("删除")
                        ])),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_ctx.editSpec(scope.row, scope.$index)), ["prevent"]),
                        disabled: _ctx.t==='view' || _ctx.t==='check'
                      }, {
                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                          _createTextVNode("编辑")
                        ])),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_button, {
              class: "mt15",
              type: "primary",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showAddSpec()))
            }, {
              default: _withCtx(() => _cache[73] || (_cache[73] = [
                _createTextVNode("添加")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        (_ctx.formData.cat_id == _ctx.BrandCat['蛋糕'])
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              class: "table-form-item",
              label: "收费附件："
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: _ctx.formData.charges,
                  style: {"width":"100%"},
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "name",
                      label: "名称"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "unity",
                      label: "单位"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "price",
                      label: "单价"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "limit",
                      label: "限购数"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "status",
                      label: "是否隐藏"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.status ? '是': '否'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      width: "150"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (_ctx.delCharge(scope.$index)), ["prevent"]),
                            disabled: _ctx.t==='view' || _ctx.t==='check'
                          }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createTextVNode("删除")
                            ])),
                            _: 2
                          }, 1032, ["onClick", "disabled"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (_ctx.editCharge(scope.row, scope.$index)), ["prevent"]),
                            disabled: _ctx.t==='view' || _ctx.t==='check'
                          }, {
                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                              _createTextVNode("编辑")
                            ])),
                            _: 2
                          }, 1032, ["onClick", "disabled"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_button, {
                  class: "mt15",
                  type: "primary",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showAddCharge()))
                }, {
                  default: _withCtx(() => _cache[76] || (_cache[76] = [
                    _createTextVNode("添加")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "原料：",
          prop: "extra_data.material",
          required: _ctx.formData.cat_id==`${_ctx.BrandCat['蛋糕']}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.material,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.extra_data.material) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["required"]),
        _createVNode(_component_el_form_item, { label: "口感：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.taste,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.extra_data.taste) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "甜度：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.extra_data.sweetness,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.extra_data.sweetness) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                    _createTextVNode("1")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 2 }, {
                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                    _createTextVNode("2")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 3 }, {
                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                    _createTextVNode("3")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 4 }, {
                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                    _createTextVNode("4")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 5 }, {
                  default: _withCtx(() => _cache[81] || (_cache[81] = [
                    _createTextVNode("5")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 6 }, {
                  default: _withCtx(() => _cache[82] || (_cache[82] = [
                    _createTextVNode("6")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 7 }, {
                  default: _withCtx(() => _cache[83] || (_cache[83] = [
                    _createTextVNode("7")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 8 }, {
                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                    _createTextVNode("8")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 9 }, {
                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                    _createTextVNode("9")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 10 }, {
                  default: _withCtx(() => _cache[86] || (_cache[86] = [
                    _createTextVNode("10")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "存储条件：",
          prop: "extra_data.storage"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.storage,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.extra_data.storage) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "包装：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.package,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.extra_data.package) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "配送范围：",
          prop: "extra_data.distribution"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.distribution,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.extra_data.distribution) = $event)),
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_ctx.formData.cat_id===_ctx.BrandCat['蛋糕'])
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "祝福语配置：",
              prop: "is_greeting"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.is_greeting,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.is_greeting) = $event)),
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[87] || (_cache[87] = [
                        _createTextVNode("支持")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[88] || (_cache[88] = [
                        _createTextVNode("不支持")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "商品标签：",
          prop: "label_name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.formData.label_name,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.label_name) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check',
              style: {"width":"500px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: "同城配送" }, {
                  default: _withCtx(() => _cache[89] || (_cache[89] = [
                    _createTextVNode("同城配送")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "全国包邮" }, {
                  default: _withCtx(() => _cache[90] || (_cache[90] = [
                    _createTextVNode("全国包邮")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "当日达" }, {
                  default: _withCtx(() => _cache[91] || (_cache[91] = [
                    _createTextVNode("当日达")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "次日达" }, {
                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                    _createTextVNode("次日达")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "定时上架：",
          prop: "is_time"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.is_time,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.is_time) = $event)),
              disabled: _ctx.t==='view'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => _cache[93] || (_cache[93] = [
                    _createTextVNode("是")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 0 }, {
                  default: _withCtx(() => _cache[94] || (_cache[94] = [
                    _createTextVNode("否")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_ctx.formData.is_time)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "上架时间：",
              prop: "examine_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.examine_time,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.examine_time) = $event)),
                  disabled: _ctx.t==='view',
                  type: "date",
                  "disabled-date": _ctx.disabledPreSaleDate,
                  "value-format": "YYYY-MM-DD",
                  placeholder: "上架日期"
                }, null, 8, ["modelValue", "disabled", "disabled-date"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.hour,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.hour) = $event)),
                  placeholder: "请选择时间",
                  disabled: _ctx.t==='view'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hourList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.t==='check')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.formData.remark,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode("商品状态：" + _toDisplayString(_ctx.formData.status ? '上架' : '下架'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode("制单人：" + _toDisplayString(_ctx.formData.admin_name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间：" + _toDisplayString(_ctx.formData.created_at), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode("审核人：" + _toDisplayString(_ctx.formData.check_status !=0 ? _ctx.formData.admin_name : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode("审核时间：" + _toDisplayString(_ctx.formData.up_time), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            ( _ctx.t==='check' && _ctx.formData.check_status===1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onCheck(1)))
                  }, {
                    default: _withCtx(() => _cache[95] || (_cache[95] = [
                      _createTextVNode("通过并上架")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.rejectDialog = true))
                  }, {
                    default: _withCtx(() => _cache[96] || (_cache[96] = [
                      _createTextVNode("驳回")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "warning",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onCheck(2)))
                  }, {
                    default: _withCtx(() => _cache[97] || (_cache[97] = [
                      _createTextVNode("通过并下架")
                    ])),
                    _: 1
                  })
                ], 64))
              : (_ctx.t!=='view' && _ctx.t!=='check')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.submitForm(2)))
                    }, {
                      default: _withCtx(() => _cache[98] || (_cache[98] = [
                        _createTextVNode("保存")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submitForm(3)))
                    }, {
                      default: _withCtx(() => _cache[99] || (_cache[99] = [
                        _createTextVNode("提交")
                      ])),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "info",
              plain: "",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => _cache[100] || (_cache[100] = [
                _createTextVNode("返回")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      modelValue: _ctx.rejectDialog,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.rejectDialog) = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.rejectDialog = false))
        }, {
          default: _withCtx(() => _cache[101] || (_cache[101] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onCheck(3)))
        }, {
          default: _withCtx(() => _cache[102] || (_cache[102] = [
            _createTextVNode("驳 回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: _ctx.reject_reason,
            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.reject_reason) = $event)),
            maxlength: "100",
            rows: 4,
            "show-word-limit": "",
            placeholder: "请输入驳回原因"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加规格信息",
      modelValue: _ctx.specDialog,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.specDialog) = $event)),
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_el_button, {
            onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.specDialog = false))
          }, {
            default: _withCtx(() => _cache[106] || (_cache[106] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.submitSpec()))
          }, {
            default: _withCtx(() => _cache[107] || (_cache[107] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.specOptions,
          inline: true,
          ref: "addSpecFrom",
          class: "demo-form-inline",
          "label-width": "120px",
          rules: _ctx.specRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "规格名称：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.name,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.specOptions.name) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "隐藏：",
              prop: "deleted"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.specOptions.deleted,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.specOptions.deleted) = $event)),
                  placeholder: "规格状态",
                  width: "200"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "否",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "是",
                      value: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "库存：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.stock,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.specOptions.stock) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "市场价：",
              prop: "market_price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.market_price,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.specOptions.market_price) = $event)),
                  autocomplete: "off",
                  placeholder: "不能小于售价",
                  onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.specOptions.market_price=_ctx.specOptions.market_price.replace(/[^0-9.]/g,'')))
                }, {
                  append: _withCtx(() => _cache[103] || (_cache[103] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "默认赠品：",
              prop: "gift"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.gift,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.specOptions.gift) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "售价：",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.price,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.specOptions.price) = $event)),
                  placeholder: "不能大于市场价",
                  onInput: _cache[46] || (_cache[46] = ($event: any) => (_ctx.specOptions.price=_ctx.specOptions.price.replace(/[^0-9.]/g,'')))
                }, {
                  append: _withCtx(() => _cache[104] || (_cache[104] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "口味或者颜色：",
              prop: "tastes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.tastes,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.specOptions.tastes) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "结算价：",
              prop: "clearing_price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.clearing_price,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.specOptions.clearing_price) = $event)),
                  placeholder: "保留2位小数",
                  onInput: _cache[49] || (_cache[49] = ($event: any) => (_ctx.specOptions.clearing_price=_ctx.specOptions.clearing_price.replace(/[^0-9.]/g,'')))
                }, {
                  append: _withCtx(() => _cache[105] || (_cache[105] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "SKU：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.sku,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.specOptions.sku) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "规格折扣：",
              prop: "shop_discount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.shop_discount,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.specOptions.shop_discount) = $event)),
                  readonly: "",
                  placeholder: "保留2位小数"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "说明：",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.specOptions.description,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.specOptions.description) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加收费附件信息",
      modelValue: _ctx.chargeDialog,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.chargeDialog) = $event)),
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.chargeDialog = false))
          }, {
            default: _withCtx(() => _cache[108] || (_cache[108] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.submitCharge()))
          }, {
            default: _withCtx(() => _cache[109] || (_cache[109] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.chargeOptions,
          ref: "addChargeFrom",
          "label-width": "120px",
          rules: _ctx.chargeRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.name,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.chargeOptions.name) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "单位：",
              prop: "unity"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.unity,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.chargeOptions.unity) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "单价：",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.price,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.chargeOptions.price) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "限购数：",
              prop: "limit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.limit,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.chargeOptions.limit) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否隐藏：",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.chargeOptions.status,
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.chargeOptions.status) = $event)),
                  width: "200"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "否",
                      value: "0"
                    }),
                    _createVNode(_component_el_option, {
                      label: "是",
                      value: "1"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}